// The IT CPV scope for the Dashboard/Saved-filters CPV prefix combobox.
// Descriptions are not maintained here — CpvCombobox resolves them from the
// official catalogue (see stores/cpvCodes.ts) by intersecting it with this
// allow-list. The backend also accepts any CPV code starting with 72 as a
// catch-all.
export const IT_CPV_CODES: readonly string[] = [
  // 48xxxxxx — software packages & information systems
  '48000000',
  '48100000',
  '48200000',
  '48218000',
  '48300000',
  '48311000',
  '48400000',
  '48422000',
  '48500000',
  '48600000',
  '48611000',
  '48613000',
  '48700000',
  '48780000',
  '48800000',
  '48810000',
  '48811000',
  '48820000',
  '48823000',
  '48825000',
  '48900000',

  // 72xxxxxx — IT services: programming, consulting, data, internet, support
  '72000000',
  '72100000',
  '72200000',
  '72210000',
  '72211000',
  '72212000',
  '72212211',
  '72220000',
  '72221000',
  '72222000',
  '72223000',
  '72224000',
  '72224100',
  '72224200',
  '72225000',
  '72226000',
  '72227000',
  '72228000',
  '72230000',
  '72232000',
  '72240000',
  '72243000',
  '72246000',
  '72250000',
  '72251000',
  '72252000',
  '72253000',
  '72253100',
  '72253200',
  '72254000',
  '72254100',
  '72260000',
  '72261000',
  '72262000',
  '72263000',
  '72265000',
  '72266000',
  '72267000',
  '72267100',
  '72267200',
  '72300000',
  '72310000',
  '72312000',
  '72314000',
  '72315000',
  '72316000',
  '72317000',
  '72319000',
  '72320000',
  '72322000',
  '72400000',
  '72410000',
  '72413000',
  '72415000',
  '72416000',
  '72420000',
  '72421000',
  '72422000',
  '72500000',
  '72510000',
  '72540000',
  '72590000',
  '72591000',
  '72600000',
  '72610000',
  '72611000',
  '72700000',
  '72710000',
  '72720000',
  '72800000',
  '72810000',
  '72820000',
  '72900000',

  '79410000',
  '79411000',
  '79411100',
  '79420000',
  '79421000',
  '79421100',
  '79421200',

  '80500000',
  '80510000',
  '80511000',
  '80531000',
  '80531200',
  '80533000',
  '80533100',
  '80533200',
]
